'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Card;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../styles/colors');

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Card(props) {
  return _react2.default.createElement(
    'div',
    { className: (0, _styles2.default)(props.background).toString() },
    props.children
  );
}

Card.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.element, _propTypes2.default.string]),
  background: _propTypes2.default.string
};

Card.defaultProps = {
  background: _colors.COLORS.white,
  children: null
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Card/index.js
// module id = 1576
// module chunks = 0